
const statusReasons = {
  401: 'bad_credentials',
  403: 'already_completed',
  408: 'timeout',
  409: 'payload_changed',
  410: 'expired',
  503: 'maintenance_mode',
  default: 'other',
}

export function getResultByStatus (status) {
  return {
    status: 'error',
    statusReason: statusReasons[status] || statusReasons.default,
  }
}
